import { Packages, PackageIds } from '~shared/constants/pricing';

// need to include Standard packages to get the spacing at the top
export const Grow2529ExperimentPackages = [
  Packages.StarterAnnual,
  Packages.StarterMonthly,
  Packages.StandardAnnual,
  Packages.StandardMonthly,
  Packages.FormsAnnual,
  Packages.FormsMonthly,
];

export const Grow2529ExperimentPackagesPartial = [Packages.StarterAnnual, Packages.FormsAnnual, Packages.FormsMonthly];

export const PACKAGE_SWAP = {
  [Packages.FormsAnnual]: {
    id: PackageIds.FORMS_ANNUAL,
    swap: {
      packageName: Packages.FormsMonthly,
      id: PackageIds.FORMS_MONTHLY,
    },
  },
  [Packages.FormsMonthly]: {
    id: PackageIds.FORMS_MONTHLY,
    swap: {
      packageName: Packages.FormsAnnual,
      id: PackageIds.FORMS_ANNUAL,
    },
  },
  [Packages.StarterAnnual]: {
    id: PackageIds.STANDARD_ANNUAL,
    swap: {
      packageName: Packages.StandardMonthly,
      id: PackageIds.STANDARD_MONTHLY,
    },
  },
  [Packages.StandardMonthly]: {
    id: PackageIds.STANDARD_MONTHLY,
    swap: {
      packageName: Packages.StarterAnnual,
      id: PackageIds.STANDARD_ANNUAL,
    },
  },
};
